import { useState } from "react";

// Components
import { SelectedCiTypeContext } from "../context/selectedCiTypeContext";
import CiTypeDrawer from "./CiTypesDrawer";
import CiTypesDeleteDialog from "./CiTypesDeleteDialog";
import CiTypesToolbar from "./CiTypesToolbar";
import CiTypesTree from "./CiTypesTree";
//import UserDeleteDialog from "./UserDeleteDialog";
//import UserDrawer from "./UserDrawer";

function CiTypes() {
  const [isCreatorOpen, setIsCreatorOpen] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [isRemoverOpen, setIsRemoverOpen] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%" }}>
      <SelectedCiTypeContext>
        <CiTypesToolbar
          setIsAddOpen={setIsCreatorOpen}
          setIsEditOpen={setIsEditorOpen}
          setIsRemoverOpen={setIsRemoverOpen}
        />
        <div style={{ flex: 1, overflow: "hidden" }}>
          <CiTypesTree />
        </div>
        <CiTypeDrawer isOpen={isCreatorOpen} setIsOpen={setIsCreatorOpen} newCiType={true} />
        <CiTypeDrawer isOpen={isEditorOpen} setIsOpen={setIsEditorOpen} newCiType={false} />
        {isRemoverOpen && <CiTypesDeleteDialog isOpen={isRemoverOpen} setIsOpen={setIsRemoverOpen} />}
      </SelectedCiTypeContext>
    </div>
  );
}

export default CiTypes;
